
import Vue from 'vue'
import SectionCountItem from "@/views/Development/Sections/Count/SectionCountItem.vue"

const FOUNDATION_YEAR = 2014

export default Vue.extend({
    name: 'SectionCount',
    components: {
        SectionCountItem
    },
    computed: {
        yearsOfExpertise (): number {
            return Math.max(new Date().getFullYear() - FOUNDATION_YEAR, 0)
        }
    }
})
